// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--dmrQb";
export var links = "footer-module--links--PDox8";
export var icons = "footer-module--icons--drvPF";
export var copyright = "footer-module--copyright--pdSo3";